import './clients.less';

// trim-below
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import block from 'bem-cn-lite';

const b = block('clients');

const CLIENTS = [
	{
		logo: '/stub/images/clients/logo1.jpg'
	},
	{
		logo: '/stub/images/clients/logo2.jpg'
	},
	{
		logo: '/stub/images/clients/logo3.jpg'
	},
	{
		logo: '/stub/images/clients/logo4.jpg'
	},
	{
		logo: '/stub/images/clients/logo5.png'
	}
];

const Clients = () => (
	<div className={b()}>
		{
			CLIENTS.map((item, index) => (
				<div className={b('item')} key={`image` + index}>
					<img src={item.logo} className={b('img')} />
				</div>
			))
		}
	</div>
);

export default Clients;



// WEBPACK FOOTER //
// ./src/components/clients/index.jsx